import styled from 'styled-components';

export const StyledReportBoxesWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const StyledPackedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledForPackingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledSalesByCityWrapper = styled.div`
  width: 420px;
`;

export const StyledTopSellingItemsWrapper = styled.div``;

export const StyledInventoryLevelsWrapper = styled.div``;
